module.exports = __webpack_public_path__ + "static/book-f0b3485b9e468437c15052fd1dfa9631.png";